<script setup lang="ts">
import BottomNavigation from '@/components/navigation/BottomNavigation.vue';
import MainNavigation from '@/components/navigation/MainNavigation.vue';
import router from '@/router';
import { LogoColor, LogoType, odsLogo } from 'omind-design-system/components/odsLogo';
import { odsLayoutDefault } from 'omind-design-system/layouts/odsLayoutDefault';
import { odsLayoutNavbar } from 'omind-design-system/layouts/odsLayoutNavbar';
</script>

<template>
  <odsLayoutNavbar v-if="router.currentRoute.value.meta.hasNav"
                   :top-navbar="true">
    <template #navigationMain>
      <MainNavigation></MainNavigation>
    </template>
    <template #navigationBottom>
      <BottomNavigation></BottomNavigation>
    </template>
    <!-- <template #mobileNavigationright>
      <div class="mobile-more-button" @click="toggleMoreNavigation()">
        <odsIcon :name="'more_vert'" :size="IconSize.Medium"></odsIcon>
      </div>
      <div class="mobile-more-backdrop" :class="{show:moreNavigationShown}" @click="hideMoreNavigation()"></div>
      <div class="mobile-more-content" :class="{show:moreNavigationShown}">
        <odsCard :shadow="Shadow.Large" class="ods-navigation-container">
          <BottomNavigation @click="hideMoreNavigation()"></BottomNavigation>
        </odsCard>
      </div>
    </template> -->
    <template #default>
      <slot>
        <div style="
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            overflow-x: hidden;
          ">
          <RouterView v-slot="{ Component, route }">
            <Transition :name="'fade'"
                        mode="out-in">
              <Suspense>
                <component :is="Component"
                           :key="route.path" />
              </Suspense>
            </Transition>
          </RouterView>
        </div>
      </slot>
      <footer>
        <odsLogo :color="LogoColor.Light"
                 :style="{ height: '2rem' }"></odsLogo>
      </footer>
      <!-- <odsBox class="loading-animation">
        <span class="loading-container">
          <span class="stars">
              <span class="shooting-star"></span>
              <span class="shooting-star"></span>
              <span class="shooting-star"></span>
              <span class="shooting-star"></span>
              <span class="shooting-star"></span>
              <span class="shooting-star"></span>
              <span class="shooting-star"></span>
          </span>
          <span class="loading-container-inner">
              <span class="loader"></span>
          </span>
        </span>
      </odsBox> -->
    </template>
  </odsLayoutNavbar>
  <odsLayoutDefault v-else>
    <RouterView v-slot="{ Component }">
      <Transition :name="'fade'"
                  mode="out-in">
        <Suspense>
          <component :is="Component" />
        </Suspense>
      </Transition>
    </RouterView>
  </odsLayoutDefault>
</template>

<style lang="scss">
@import 'omind-design-system/assets/styles/tokens';

/* .v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
} */

.ods-layout-navbar .ods-content-container {
  overflow: visible;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 350ms ease;
  //transition: transform 350ms ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  //transform: translate(-100%,0);
}

.ods-box.loading-animation {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  padding-left: 320px;
}

.ods-content-container {
  &>.ods-box {
    background-color: var(--color-neutral-100);
    min-height: 100%;
  }
}

.loading-container {
  flex: 0 0 7rem;
  height: 7rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms ease-out;
  background-color: var(--color-blue-900);
  opacity: 1;
  transform: scale(1, 1);
  transition-delay: 0ms;
  border-radius: var(--border-radius-full);
  overflow: hidden;

  .loader {
    transform: translate(0, 50%);
  }

  .stars {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: rotateZ(160deg);
    // animation: sky 200000ms linear infinite;
  }
}

footer {
  background-color: var(--content-label-900);
  width: 100%;
  height: auto;
  flex-direction: row;
  gap: var(--spacing-2xl);
  padding: var(--spacing-medium);
}

.fade-enter-active~.loading-animation .loading-container,
.fade-leave-active~.loading-animation .loading-container {
  opacity: 1;
  transform: scale(1, 1);
}

@media ($breakpoint-tablet) {
  .ods-mobile-navigation-right {
    position: relative;
  }

  .mobile-more-button {
    color: var(--color-neutral-100);
  }

  .mobile-more-content {
    width: 140px;
    position: absolute;
    right: 0;
    top: 2rem;
    transition:
      opacity 150ms ease-out,
      transform 150ms ease-out;
    opacity: 0;
    transform: scale(0, 0);
    transform-origin: top right;
    pointer-events: none;

    .ods-navigation-container {
      height: auto;
      background-color: var(--color-neutral-100);

      .ods-navigation {
        height: auto;
        padding: var(--spacing-standard);
        flex-direction: column;
        gap: var(--spacing-standard);
        justify-content: flex-start;

        .ods-navigation-item {
          flex-direction: row;
          gap: var(--spacing-small);
          color: var(--content-body-900);
          justify-content: flex-start;

          .ods-icon {
            flex: 0 0 1.5rem;
          }
        }
      }
    }

    &.show {
      opacity: 1;
      transform: scale(1, 1);
      pointer-events: all;
    }
  }

  .mobile-more-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    opacity: 0;
    pointer-events: none;

    &.show {
      opacity: 1;
      pointer-events: all;
    }
  }
}

.loading-container-inner {
  transform: scale(0.3, 0.3) rotate(70deg) translate(0px, -25px);
}

$rocket-color: var(--color-orange-500);

.loader {
  width: 32px;
  height: 90px;
  display: block;
  margin: 20px auto;
  position: relative;
  border-radius: 50% 50% 0 0;
  border-bottom: 10px solid $rocket-color;
  background-color: var(--color-neutral-10);
  background-image:
    radial-gradient(ellipse at center,
      var(--color-neutral-10) 34%,
      $rocket-color 35%,
      $rocket-color 54%,
      var(--color-neutral-10) 55%),
    linear-gradient($rocket-color 10px, transparent 0);
  background-size: 28px 28px;
  background-position:
    center 20px,
    center 2px;
  background-repeat: no-repeat;
  box-sizing: border-box;
  animation: animloaderBack 1s linear infinite alternate;
}

.loader::before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 44px;
  border-radius: 50%;
  box-shadow: 0px 15px $rocket-color inset;
  top: 67px;
}

.loader::after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 34px;
  height: 34px;
  top: 112%;
  background: radial-gradient(ellipse at center,
      #ffdf00 8%,
      rgba(249, 62, 0, 0.6) 24%,
      rgba(0, 0, 0, 0) 100%);
  border-radius: 50% 50% 0;
  background-repeat: no-repeat;
  background-position: -44px -44px;
  background-size: 100px 100px;
  box-shadow: 4px 4px 12px 0px rgba(255, 61, 0, 0.5);
  box-sizing: border-box;
  animation: animloader 1s linear infinite alternate;
}

$shooting-time: 2000ms;

.shooting-star {
  position: absolute;
  left: 50%;
  top: 50%;
  // width: 100px;
  opacity: 0.5;
  height: 2px;
  background: linear-gradient(-45deg, var(--color-neutral-100), rgba(0, 0, 255, 0));
  border-radius: var(--border-radius-full);
  filter: drop-shadow(0 0 6px var(--color-neutral-100));
  animation:
    tail $shooting-time ease-in-out infinite,
    shooting $shooting-time ease-in-out infinite;

  @for $i from 1 through 20 {
    &:nth-child(#{$i}) {
      $delay: random(9999) + 0ms;
      top: calc(50% - #{random(100) - 50px});
      left: calc(50% - #{random(300) + 100px});
      animation-delay: $delay;
      // opacity: random(50) / 100 + 0.5;

      &::before,
      &::after {
        animation-delay: $delay;
      }
    }
  }
}

@keyframes tail {
  0% {
    width: 0;
  }

  30% {
    width: 100px;
  }

  100% {
    width: 0;
  }
}

@keyframes shining {
  0% {
    width: 0;
  }

  50% {
    width: 30px;
  }

  100% {
    width: 0;
  }
}

@keyframes shooting {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(500px);
  }
}

@keyframes animloaderBack {

  0%,
  30%,
  70% {
    transform: translateY(0px);
  }

  20%,
  40%,
  100% {
    transform: translateY(-5px);
  }
}

@keyframes animloader {
  0% {
    box-shadow: 4px 4px 12px 2px rgba(255, 61, 0, 0.75);
    width: 34px;
    height: 34px;
    background-position: -44px -44px;
    background-size: 100px 100px;
  }

  100% {
    box-shadow: 2px 2px 8px 0px rgba(255, 61, 0, 0.5);
    width: 30px;
    height: 28px;
    background-position: -36px -36px;
    background-size: 80px 80px;
  }
}
</style>
